import { SelectInputItem } from '@fmnts/declarative-forms';
import { filter, MonoTypeOperatorFunction } from 'rxjs';

/**
 * @param items Items from the select field
 *
 * @returns
 * An operator that filters emission of an source observable
 * and emits only if the value is present in the provided `items`.
 *
 * @example
 * items = [{value: 'unique'}];
 * of('some', 'unique', 'value').pipe(
 *  filterValueInSelectItems(items)
 * ) // -> emits 'unique'
 */
export function filterValueInSelectItems(
  items: readonly SelectInputItem[],
): MonoTypeOperatorFunction<unknown> {
  return filter((value) => items.find((i) => i.value === value) !== undefined);
}
